import styled from 'styled-components';

export const StickySelectDiaperCTA = styled.div`
  position: fixed;
  bottom: -1px;
  z-index: 99;
  width: 100%;
  max-width: 85%;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #fff;
  box-shadow: 0 -3px 6px 0 rgba(114, 114, 114, 0.16);
  @media (max-width: 720px) {
    max-width: 100%;
    min-height: 100.67px;
  }
`;

export const SelectDiaperStrip = styled.div`
  background: ${(props) => (props.isForNewCdPage ? '#6094b9' : '#6e8f6c')};
  text-align: center;
  color: #fff;
  font-weight: 500;
  padding: 6px;
  font-size: ${(props) => (props.isForNewCdPage ? '12px' : '14px')};
`;

export const FlexBox = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
  align-items: center;
  max-width: ${(props) => (props.experimentUserType === 'A' ? '65%' : '90%')};
  margin: auto;
  margin: ${(props) => (!props.showMargin ? '23px auto' : '6px auto')};
  @media (max-width: 720px) {
    margin: ${(props) => (!props.showMargin ? '14px 10px' : '6px 10px')};
    padding: 0;
    max-width: 100%;
  }
`;

export const EmptyBoxContainer = styled.div`
  flex-basis: 30%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 720px) {
    flex-basis: 57%;
  }
`;

export const EmptyBox = styled.div`
  width: 100%;
  max-width: ${(props) => (props.image ? '31.5%' : '23%')};
  height: ${(props) => (props.image ? '77px' : '42px')};
  line-height: ${(props) => (props.free ? '42px' : '36px')};
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #70707099;
  border: ${(props) => (props.image ? 'none' : '1px dashed #707070')};
  border-radius: 8px;
  position: relative;
  @media (min-width: 720px) {
    cursor: pointer;
  }
  @media (max-width: 720px) {
    height: ${(props) => (props.image ? '60px' : '42px')};
  }
`;
export const EmptyImageBox = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

export const PlusIcon = styled.span`
  font-size: clamp(19px, 3vw, 28px);
  font-weight: 600;
  color: #70707099;
`;

export const CrossButton = styled.span`
  position: absolute;
  top: 0px;
  height: 16px;
  color: #fff;
  display: inline-block;
  background: #000;
  line-height: 14px;
  border-radius: 50%;
  width: 16px;
  right: 0px;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;

  @media (max-width: 720px) {
    cursor: default;
  }
`;

export const ProceedButton = styled.button`
  height: 44px;
  line-height: 44px;
  padding: 0 6px 0 20px;
  text-align: center;
  background-color: ${(props) => (props.proceed ? '#ef4e5e' : '#dbdbdb')};
  color: #fff;
  border: none;
  outline: none;
  border-radius: 4px;
  flex-basis: 40%;
  font-weight: 600;
  font-family: 'Montserrat';
  cursor: pointer;
  position: relative;
  overflow: hidden;

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: rippleB 600ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes rippleB {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  cursor: default;
  height: 38px;
  line-height: 38px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: 35%;
  gap: 10px;
  img {
    display: block;
    transform: rotate(-90deg);
  }
  @media (max-width: 720px) {
    justify-content: space-between;
    gap: 0px;
  }
`;

export const GifContainer = styled.div`
  position: fixed;
  bottom: -60px;
  width: 100%;
  left: 0;
  right: 0;
  margin: auto;

  img {
    width: 26%;

    @media (max-width: 720px) {
      width: 80%;
    }
  }
`;

export const FreeStrip = styled.span`
  display: inline-block;
  width: 100%;
  background: ${(props) => (props.isForNewCdPage ? '#000' : '#fafafad9')};
  color: ${(props) => (props.isForNewCdPage ? '#fff' : '#63b0a8')};
  font-weight: 500;
  position: absolute;
  bottom: 0;
  z-index: 9;
  height: 18px;
  line-height: 18px;
  left: 0;
  text-align: center;
  font-size: clamp(10px, 2vw, 11px);
`;

export const SelectedDaipersSection = styled.div`
  flex-basis: 30%;
  display: flex;
  align-items: center;
  background-color: #fff;
  font-weight: 600;
  column-gap: 10px;
  span {
    font-size: 16px;
    font-weight: 500;
    color: #6e6e6e;
  }
  @media (max-width: 720px) {
    flex-basis: 50%;
  }
`;
